import { createAction } from 'redux-actions';

export const setCurrentAdSlot = createAction('SET_CURRENT_ADSLOT', slot => ({ slot }));
export const updateQuery = createAction('UPDATE_ADSLOT_QUERY', query => ({ query }));
export const updatePage = createAction('UPDATE_ADSLOT_PAGE', activePage => ({ activePage }));

export const getAdSlots = createAction('GET_ADSLOTS');
export const getAdSlotsSuccess = createAction('GET_ADSLOTS_SUCCESS', (slots, count) => ({ slots, count }));
export const getAdSlotsFail = createAction('GET_ADSLOTS_FAIL', error => ({ error }));

export const searchAdSlots = createAction('SEARCH_ADSLOTS', query => ({ query }));
export const searchAdSlotsSuccess = createAction('SEARCH_ADSLOTS_SUCCESS', slots => ({ slots }));
export const searchAdSlotsFail = createAction('SEARCH_ADSLOTS_FAIL', error => ({ error }));

export const getAdSlotById = createAction('GET_ADSLOT_BY_ID', id => ({ id }));
export const getAdSlotByIdSuccess = createAction('GET_ADSLOT_BY_ID_SUCCESS', slot => ({ slot }));
export const getAdSlotByIdFail = createAction('GET_ADSLOT_BY_ID_FAIL', error => ({ error }));

export const addAdSlot = createAction('ADD_ADSLOT', (slot, firmId) => ({ slot, firmId }));
export const addAdSlotSuccess = createAction('ADD_ADSLOT_SUCCESS', slot => ({ slot }));
export const addAdSlotFail = createAction('ADD_ADSLOT_FAIL', error => ({ error }));

export const updateAdSlot = createAction('UPDATE_ADSLOT', (slot, firmId) => ({ slot, firmId }));
export const updateAdSlotSuccess = createAction('UPDATE_ADSLOT_SUCCESS', slot => ({ slot }));
export const updateAdSlotFail = createAction('UPDATE_ADSLOT_FAIL', error => ({ error }));

export const updateCurrentAdSlotItems = createAction('UPDATE_CURRENT_ADSLOT', itemIds => ({ itemIds }));
export const updateCurrentAdSlotItemsSuccess = createAction('UPDATE_CURRENT_ADSLOT_SUCCESS', slot => ({ slot }));
export const updateCurrentAdSlotItemsFail = createAction('UPDATE_CURRENT_ADSLOT_FAIL');

export const getItemsForFirms = createAction('GET_ITEMS_FOR_FIRMS', firmIds => ({ firmIds }));
export const getItemsForFirmsSuccess = createAction('GET_ITEMS_FOR_FIRMS_SUCCESS', items => ({ items }));
export const getItemsForFirmsFail = createAction('GET_ITEMS_FOR_FIRMS_FAIL', error => ({ error }));

export const showAdSlotModal = createAction('SHOW_ADSLOT_MODAL');
export const hideAdSlotModal = createAction('HIDE_ADSLOT_MODAL');
